var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimStateApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-248-261h1200v1625h-1200z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#69db7c",
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.9129464 15.2678863c-.3437517.3356965-.7433013.5035423-1.1986607.5035423s-.85490898-.1678458-1.1986607-.5035423l-2.40401786-2.3411444c-.1696437-.1700281-.25446428-.3662114-.25446428-.5885558 0-.2223445.0870527-.4185278.26116071-.5885559.16964371-.1656684.36830243-.2485014.59598214-.2485014s.42857056.082833.60267858.2485014l2.39732141 2.3476839 5.3973214-5.27738417c.1741081-.1656684.3749989-.24850136.6026786-.24850136s.4285706.08283296.6026786.24850136c.1696437.1700281.2544643.36621143.2544643.58855586 0 .22234444-.0848206.41852776-.2544643.58855586z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimStateApproved);
export default __webpack_public_path__ + "static/media/claim-state-approved.5483d828fe697ede5b46ee6f7a7fe425.svg";
export { ForwardRef as ReactComponent };